<template>
  <div class="genera" style="background-color: #ffffff">
    <barraNavegacionPublic class="barraNavegacionPublic"></barraNavegacionPublic>
    <cuerpo class="cuerpo"></cuerpo>
    <footerPublic class="footerPublic"></footerPublic>
  </div>
</template>

<script>
  import barraNavegacionPublic from './share/barraNavegacion';
  import cuerpo from './fragmentosUnaCategoria/cuerpo';
  import footerPublic from './share/footer';

  export default {
    name: "unaCategoria",
    components: {
      barraNavegacionPublic,
      cuerpo,
      footerPublic
    },
    data() {
      return {
        styleObject: {
          navegacionPublica: {
            fondo: {'background-color': '#4b4b4b'},
            colorTexto: {color: '#ffffff'}
          },
          fondoBase: {'background-color': '#e3dcff'}
        }
      }
    },
    mounted() {
      // this.cargarEstilos();
    },
    created() {
      $(document).ready(function () {
        $('body').bootstrapMaterialDesign();
      });
    },
    methods: {
      /*cargarEstilos() {
        EventBus.$emit('barraNavegacion', this.styleObject.navegacionPublica);
      }*/
    }
  }
</script>

<style scoped lang="scss">
  .genera {
    min-height: 100vh;
  }

  .barraNavegacionPublic {
    height: 8vh;
  }

  .cuerpo {
    min-height: 62vh;
    /*margin-bottom: 25px;*/
  }

  .footerPublic {
    height: 10vh;
  }
</style>



// WEBPACK FOOTER //
// src/components/publico/una_categoria.vue